module.exports = __webpack_public_path__ + "img/copied.0f0f9161.png";